import './toast.css'
var timeNeed
function messageIntoDOM(options) {
	var { type, describe: { text = "", title = "" }, delay } = options
	var body = document.getElementsByTagName('body')[0]
	var div = document.createElement('div')
	var messageDiv = document.querySelector(".su-messageInfo");
	if (messageDiv) {
		setTimeout(function () {
			messageIntoDOM(options)
		}, timeNeed)
		return
	}

	var html = `
	<div class="su-messageInfo" style="animation: messageIn .3s">
		<div class="su-message-wrap">
			${title ? `<span>${title}</span>` : ''}
			${text ? `<span>${text}</span>` : ''}
		</div>
	</div>
	`
	div.innerHTML = html
	body.appendChild(div)
	timeNeed = delay + 300 * 2
	setTimeout(function () {
		document.querySelector(".su-messageInfo").style.opacity = "0"
		document.querySelector(".su-messageInfo").style.animation = "messageOut .3s"
		setTimeout(function () {
			body.removeChild(div)
		}, 200)
	}, delay || 1000)
}
var toast = {
	info: function (options) {
		messageIntoDOM({ type: 'info', ...options })
	}
}
export default toast